import React, { useState, useEffect } from 'react';
import { Dropdown } from 'bootstrap';
import axiosInstance from '../../axiosInstance';


const API_URL = process.env.REACT_APP_API_URL;


const NavMessage = () => {
  
  const [message, setMessage] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    const dropdownElement = document.querySelector('[data-bs-toggle="dropdown"]');
    if (dropdownElement) {
      new Dropdown(dropdownElement); 
    }
  }, []);
 


  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axiosInstance.get(`${API_URL}/api/data`);
        const data = response.data;
        
        // Ensure files array exists for each order
        const newOrderMessages = data.newOrder.map(order => ({
          ...order,
          files: order.files || [] // Correct syntax without semicolon
        }));
  
        setMessage(newOrderMessages);
        
      } catch (error) {
        console.error('Error fetching messages:', error);
        setError('Failed to fetch messages');
      }
    };
  
    fetchMessages();
  }, []); // Empty dependency array = runs once on mount

  const handleDownload = async (filename) => {
    try {
      const response = await axiosInstance.get(`${API_URL}/api/data/download/${filename}`, {
        responseType: 'blob'
      });
      
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error('Download failed:', error);
      setError('File download failed');
    }
  };
  
  

  const handleDelete = async (messageId) => {
    try {
      await axiosInstance.delete(`${API_URL}/api/data/delete/${messageId}`);
      setMessage(message.filter(message => message._id !== messageId));
    } catch (error) {
      console.error('Error deleting message:', error);
      setError('Failed to delete message');
    }
  };

  return (
    <>
      <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
     
        <span className="admin-badge-number">{message.length}</span>
      </a>
      <li className="nav-item dropdown">
      
      <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow messages" style={{ backgroundColor: "transparent", boxShadow: "none" }}>
        {error && <div className="dropdown-header text-danger">{error}</div>}
        {message.length === 0 ? (
          <div className="dropdown-header">No new messages</div>
        ) : (
          message.map((msg, index) => (
            <React.Fragment key={msg._id}>
              <div className="message-container">
                {/* First row - deadline aligned right */}
                <div className="message-deadline-row">
                  <span className="message-deadline">{msg.deadline}</span>
                </div>
                <span className="message-divider" />
  
                {/* Second row - document type and buttons */}
                <div className="message-doc-row">
                  <span className="message-document-type"> &nbsp;{msg.documentType} &nbsp;</span>
                  <span className="message-document-type">${msg.total}</span>
                  <div className="message-header-buttons">
                    {msg.files?.map((filename, index) => {
                      const getFileLabel = (filename) => {
                        const extension = filename.split('.').pop().toLowerCase();
                        
                        if (['jpeg', 'jpg', 'png'].includes(extension)) {
                          return 'Image';
                        }
                        if (extension === 'mp3') {
                          return 'Audio';
                        }
                        if (extension === 'mp4') {
                          return 'Video';
                        }
                        return 'Draft'; // Everything else (PDF, DOC, XLS, TXT, etc.)
                      };

                      return (
                        <button 
                          key={index}
                          onClick={() => handleDownload(filename)}
                          className="btn btn-draft"
                        >
                          {getFileLabel(filename)}
                        </button>
                      );
                    })}
                    <button 
                      onClick={() => handleDelete(msg._id)} 
                      className="btn btn-remove"
                    >
                      Remove
                    </button>
                    
                  </div>
                </div>
  
             
                 
               
  
                {/* Fourth row - scrollable instructions */}
                <div className="message-instructions-container">
                  <div className="message-instructions">{msg.email} writes: {msg.instructions}&nbsp;|&nbsp;{msg.couponCode}</div>
                </div>
  
             
              </div>
            </React.Fragment>
          ))
        )}
      </div>
    </li>
      
    </>
    
  );
};

export default NavMessage;
